import notificationService from '../../../services/notification.service'

export default {
  async getNotifications({ dispatch, commit }, mailBox) {
    return await notificationService.getNotifications(mailBox)
      .then(response => {
        if (response.status || response.success) {
          return Promise.resolve(response.data);
        } else {
          // dispatch("alertError", typeof response.message == 'object' ? response.message[0] : response.message, { root: true })
        }
      }).catch(error => {
        // dispatch("alertError", error, { root: true });
        // return Promise.reject(false);
      })
  },
}
